module.exports = __webpack_public_path__ + "static/media/s_volley_ball.76675f70.mp3";